import { useReducer, useRef } from "react";
import { useDispatch } from "react-redux";
import useHttp from "../../../hooks/use-http";
import { authActions } from "../../../store/auth";
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points";

import { useEffect } from "react";

import { saveLocalData } from "../../../helpers/storage-helper";
import { useHistory } from "react-router-dom";
import { cuteToast } from "../../UI/cute";

const emailReducer = (state, action) => {
  switch (action.type) {
    case "USER_INPUT":
      return {
        value: action.value,
        isValid: /\S+@\S+\.\S+/.test(action.value),
      };
    case "USER_INPUT_BLUR":
      return { value: state.value, isValid: /\S+@\S+/.test(state.value) };
    default:
      return { value: "", isValid: false };
  }
};

const passwordReducer = (state, action) => {
  switch (action.type) {
    case "USER_INPUT":
      return { value: action.value, isValid: action.value.trim().length > 6 };
    case "USER_INPUT_BLUR":
      return { value: state.value, isValid: state.value.trim().length > 0 };
    default:
      return { value: "", isValid: false };
  }
};

const Login = ({ onForgotClick }) => {
  const history = useHistory();
  const [emailState, dispatchEmail] = useReducer(emailReducer, {
    value: "",
    isValid: null,
  });
  const [passwordState, dispatchPassword] = useReducer(passwordReducer, {
    value: "",
    isValid: null,
  });
  const dispatch = useDispatch();

  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: logInRequest,
  } = useHttp();

  const emailRef = useRef();
  const passwordRef = useRef();

  const responseHandle = (response) => {
    saveLocalData("sitebuilder_user", response);
    dispatch(
      authActions.login({
        token: response.token,
        roles: response.roles,
        first_name: response.first_name,
        last_name: response.last_name,
        access: response.access,
        email: response.email,
        whitelabel: response.whitelabel,
      })
    );
    history.push("/");
  };

  const submitHandler = (event) => {
    event.preventDefault();

    if (!emailState.isValid) {
      emailRef.current.focus();
      dispatchEmail({ type: "USER_INPUT_BLUR" });
    } else if (!passwordState.isValid) {
      passwordRef.current.focus();
      dispatchPassword({ type: "USER_INPUT_BLUR" });
    }

    if (emailState.isValid && passwordState.isValid) {
      const userData = {
        username: emailState.value,
        password: passwordState.value,
      };

      logInRequest(
        {
          url: endPoints.login,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: userData,
        },
        responseHandle
      );
    }
  };

  const emailChangeHandler = (event) => {
    dispatchEmail({ type: "USER_INPUT", value: event.target.value });
  };

  const validateEmail = () => {
    dispatchEmail({ type: "USER_INPUT_BLUR" });
  };

  const passwordChangeHandler = (event) => {
    dispatchPassword({ type: "USER_INPUT", value: event.target.value });
  };

  const validatePassword = () => {
    dispatchPassword({ type: "USER_INPUT_BLUR" });
  };

  useEffect(() => {
    if (error && httpStatusCode) {
      setError(null);
      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "",
      });
    }
  });

  return (
    <form onSubmit={submitHandler} method="post">
      {/* Hidden elements for old layout compat */}
      <img
        src={endPoints.logo}
        className="img-fluid"
        alt="img"
      />
      <h1 className="p2">Sign in</h1>
      {error && <h3>{error}</h3>}

      {/* Redesigned fields */}
      <div className="auth-field">
        <label>Email Address</label>
        <Input
          ref={emailRef}
          type="email"
          placeholder="name@company.com"
          onChange={emailChangeHandler}
          onBlur={validateEmail}
          inputClass={`${emailState.isValid === false ? "invalid" : ""}`}
        />
      </div>

      <div className="auth-field">
        <label>Password</label>
        <Input
          ref={passwordRef}
          type="password"
          placeholder="Enter your password"
          onChange={passwordChangeHandler}
          onBlur={validatePassword}
          inputClass={`${passwordState.isValid === false ? "invalid" : ""}`}
        />
      </div>

      <div className="auth-actions-row">
        <label className="auth-remember">
          <input type="checkbox" />
          <span>Remember me</span>
        </label>
        {onForgotClick && (
          <button
            type="button"
            className="auth-forgot-link"
            onClick={onForgotClick}
          >
            Forgot Password?
          </button>
        )}
      </div>

      <button type="submit" className="auth-submit-btn">Sign In</button>
    </form>
  );
};

export default Login;
